import { newsImageConfig } from "@slfinrtl/news-service-routes"
import type { NewsImageContentType, NewsImageUploadUrlView } from "@slfinrtl/ui-bff-routes"
import { createNewsImageUploadUrlRoute } from "@slfinrtl/ui-bff-routes"
import axios from "axios"
import { useCallback, useContext } from "react"
import { getAxiosInstance } from "../../../dealershipList/common/getAxiosInstance/getAxiosInstance"
import { RequestContext } from "../../../dealershipList/requestContext/RequestContext"

const isAllowedContentType = (contentType: string): contentType is NewsImageContentType =>
	newsImageConfig.allowedContentTypes.some((allowedContentType) => allowedContentType === contentType)

/** @returns a function that uploads an image and resolves with its id, onProgress gets the sent share of the image from 0 to 1 */
export const useNewsImageUpload = () => {
	const { environment, getAuthorizationHeader } = useContext(RequestContext)

	return useCallback(
		async (file: File, onProgress: (progress: number) => void): Promise<string> => {
			if (!isAllowedContentType(file.type)) {
				throw new Error(`Content type ${file.type} is not allowed for news images`)
			}
			const axiosInstance = await getAxiosInstance({ environment, getAuthorizationHeader })
			const { data } = await axiosInstance[createNewsImageUploadUrlRoute.method]<NewsImageUploadUrlView>(
				createNewsImageUploadUrlRoute.buildUrl({}),
				{ contentLength: file.size, contentType: file.type },
			)
			// the presigned url must not receive the authorization header of the BFF
			await axios.put(data.uploadUrl, file, {
				headers: { "content-type": file.type },
				onUploadProgress: ({ progress }) => {
					if (progress !== undefined) {
						onProgress(progress)
					}
				},
			})
			return data.imageId
		},
		[environment, getAuthorizationHeader],
	)
}
